import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { MultiComponent } from './../multi/multi.component';
import { ClickOutsideDirective } from './../multi/click-outside.directive';
import { ListFilterPipe } from './../multi/list-filter-pipe.pipe';
import {FormsModule} from '@angular/forms';
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [
      MultiComponent,
      ClickOutsideDirective,
      ListFilterPipe

    ],
    providers: [],
    exports: [MultiComponent, ClickOutsideDirective, ListFilterPipe]
})
export class MultiModule { }


// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/multi/multi.module.ts